import { provideRouter, Routes, withRouterConfig } from "@angular/router";
import { AuthGuard } from "./shared/guards/auth.guard";
import { AccueilComponent } from "./features/accueil/accueil.component";
import { MesInformationsComponent } from "./features/utilisateurs/mes-informations/mes-informations.component";
import { Constantes } from "./shared/constantes";
import { NousJoindreComponent } from "./features/nous-joindre/nous-joindre.component";
import { NousJoindrePublicResolver, NousJoindreResolver } from "./features/nous-joindre/nous-joindre.resolver";
import { PilotageComponent } from "./features/pilotage/pilotage.component";
import { CarteComponent } from "./features/carte/carte.component";
import { ConditionsUtilisationComponent } from "./features/conditions-utilisation/conditions-utilisation.component";
import { ConditionsUtilisationPesComponent } from "./features/conditions-utilisation-pes/conditions-utilisation-pes.component";
import { EnvironmentProviders } from "@angular/core";

export const DefaultRoutes: Routes = [];

export function provideAppRouting(): EnvironmentProviders {
  return provideRouter(
    DefaultRoutes,
    withRouterConfig({
      onSameUrlNavigation: 'reload'
    })
  );
}

export const LegereRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'carte'
  },
  {
    path: 'nous-joindre',
    component: NousJoindreComponent,
    resolve: {
      courrielSupport: NousJoindrePublicResolver
    }
  },
  {
    path: 'carte',
    component: CarteComponent,
    data: {
      cacherEntete: false
    }
  },
  {
    path: 'conditions-utilisation',
    component: ConditionsUtilisationComponent
  },
  {
    path: '**',
    redirectTo: 'carte'
  }
];

export const PesRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'accueil'
  },
  {
    path: 'accueil',
    component: AccueilComponent,
  },
  {
    path: 'nous-joindre',
    component: NousJoindreComponent,
    resolve: {
      courrielSupport: NousJoindreResolver
    }
  },
  {
    path: 'utilisateur/mes-informations',
    component: MesInformationsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'carte',
    component: CarteComponent,
    canActivate: [AuthGuard],
    data: {
      doesntHaveRole: {
        role: Constantes.Roles.RU_ACCES_INTRA_SIG
      },
      cacherEntete: true
    }
  },
  {
    path: 'conditions-utilisation',
    component: ConditionsUtilisationPesComponent
  },
  {
    path: '**',
    redirectTo: 'accueil'
  }
];

export const IntranetRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'accueil'
  },
  {
    path: 'accueil',
    component: AccueilComponent,
  },
  {
    path: 'nous-joindre',
    component: NousJoindreComponent,
    resolve: {
      courrielSupport: NousJoindreResolver
    }
  },
  {
    path: 'carte',
    component: CarteComponent,
    canActivate: [AuthGuard],
    data: {
      cacherEntete: true
    }
  },
  {
    path: 'pilotage',
    component: PilotageComponent,
    canActivate: [AuthGuard],
    data: {
      requiredRole: Constantes.Roles.Pilote
    }
  },
  {
    path: '**',
    redirectTo: 'accueil'
  }
];
